import { WatchFunnelService } from '../../../../services/watch-funnel.service';
import { Component, OnInit, EventEmitter } from '@angular/core';
import { PaginationTemplate } from '../../../../interfaces/pagination';
import { IApplication, IAccount } from '../../../../interfaces/graph-types';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { FunnelService } from '../../../../services/funnel.service';
import { CandidateService } from '../../../../services/candidate.service';
import { Subject, BehaviorSubject, Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { ModalOptions, BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfirmDeleteApplicationsComponent } from '../../../modals/confirm-delete-applications/modal-confirm-delete-applications.component';
import { AccountService } from '../../../../services/account.service';
import { ModalConfirmComponent } from '../../../modals/confirm-delete-candidates/modal-confirm.component';
import { ModalConfirmResumeComponent } from '../../../modals/confirm-resume/modal-confirm-resume.component';

interface IApplicationSelectable extends IApplication {
  selected?: boolean;
}

@Component({
  selector: '[account-funnel-applications]',
  template: require('./account-funnel-applications.component.pug'),
  styles: [require('./account-funnel-applications.component.css').toString()],
})
export class AccountFunnelApplicationsComponent {
  private funnelId: string = null;
  private stage: number = null;
  sub: any = null;
  applicationPagination: PaginationTemplate<IApplicationSelectable>;

  subjectApplicationIds: BehaviorSubject<string[]>;
  countSelected: BehaviorSubject<number>;
  countTotal: BehaviorSubject<number>;
  candidateSubjectId: Subject<string>;
  applicationSubjectId: Subject<string>;
  companySubjectId: Subject<string>;
  hasError = false;

  private accountId$: Subscription;
  accountId: string;

  deleteApplications$: Subscription;
  maxSize = 10;
  itemPerPage = 30;
  bulkActions: any = null;
  currentPage: number = 1;
  now: Date = new Date();
  allPages = false;

  applicationStageClasses = {
    30: 'badge-primary',
    40: 'badge-danger',
    50: 'badge-unsub',
    60: 'badge-warning',
    70: 'badge-warning',
    100: 'badge-success',
    130: 'badge-success',
    500: 'badge-secondary',
  };

  // -------------------------------------------------------------------
  constructor(
    private watchFunnel: WatchFunnelService,
    private apollo: Apollo,
    private watchAccount: WatchAccountService,
    private candidateService: CandidateService,
    private accountService: AccountService,
    private funnelService: FunnelService,
    private modalService: BsModalService,
  ) {
    this.subjectApplicationIds = new BehaviorSubject<string[]>(null);
    this.countTotal = new BehaviorSubject<number>(0);
    this.countSelected = new BehaviorSubject<number>(0);
    this.candidateSubjectId = new Subject<string>();
    this.applicationSubjectId = new Subject<string>();
    this.companySubjectId = new Subject<string>();

    this.bulkActions = [
      { name: 'Delete', trigger: this.initDeleteApplicationsModal.bind(this) },
      // { name: 'Cancel', trigger: this.initCancelApplicationsModal.bind(this) },
      // { name: 'Resume', trigger: this.initResumeApplicationsModal.bind(this) },
      // {
      //   name: 'Email me as CSV',
      //   trigger: this.initExportApplicationsModal.bind(this),
      // },
    ];

    setInterval(() => {
      this.now = new Date();
    }, 10000);
  }

  // -------------------------------------------------------------------
  buildQuery() {
    let a = this.apollo.watchQuery<{ account: IAccount }>({
      query: gql`
        query funnelApplicationPagination(
          $first: Int
          $last: Int
          $after: String
          $before: String
          $funnelId: ID!
          $stage: Int
          $searchFilter: String
          $skip: Int
        ) {
          funnel(funnelId: $funnelId) {
            id
            applications(
              first: $first
              last: $last
              after: $after
              before: $before
              stage: $stage
              skip: $skip
              searchFilter: $searchFilter
            ) {
              totalCount
              pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
              }
              edges {
                node {
                  id
                  stage
                  stageName
                  stepCount
                  stepType
                  detailedType
                  score
                  completedAt
                  createdAt
                  error
                  source
                  candidate {
                    id
                    name
                    email
                    firstName
                    lastName
                    avatarUrl
                    internetSpeed
                  }
                }
              }
            }
          }
        }
      `,
      fetchPolicy: 'network-only',
    });

    return a;
  }

  funnelData = null;

  searchFilter = { include_stages: [], has_error: this.hasError };

  // -------------------------------------------------------------------
  ngOnInit(): void {
    let query = this.buildQuery();

    this.accountId$ = this.watchAccount.accountId().subscribe(accountId => {
      this.accountId = accountId;

      this.sub = this.watchFunnel.funnelId().subscribe(funnelId => {
        this.funnelId = funnelId;

        this.applicationPagination = new PaginationTemplate<IApplication>(
          this.apollo,
          this.accountId,
          query,
          'funnel',
          'applications',
          this.funnelId,
          this.stage,
          this.searchFilter,
          () => {
            this.countTotal.next(this.applicationPagination.totalCount);
          },
        );
      });
    });
  }

  // -------------------------------------------------------------------
  isFuture(processAt) {
    let compareWith = new Date(processAt);
    return compareWith > this.now;
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    this.sub.unsubscribe();
    if (this.deleteApplications$) {
      this.deleteApplications$.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  setStage(stage: number): void {
    this.stage = stage;
    this.applicationPagination.setStage(stage);
    this.applicationPagination.setOffset(0);
  }

  // -------------------------------------------------------------------
  pageChanged({ page }: { page: number }): void {
    this.currentPage = page;
    // Load page
    this.applicationPagination.setOffset((this.currentPage - 1) * 30);
  }

  // -------------------------------------------------------------------
  hideAvatar(company) {
    company.avatarUrl = null;
  }

  viewingCandidate: string;
  // -------------------------------------------------------------------
  selectCandidateInfo(application) {
    this.viewingCandidate = application.candidate.id;
    // this.candidateSubjectId.next(application.candidate.id);
    this.applicationSubjectId.next(application.id)
  }

  // -------------------------------------------------------------------
  getAccountId() {
    return this.watchAccount.accountId().getValue();
  }

  // -------------------------------------------------------------------
  closeCandidateInfo() {
    this.viewingCandidate = null;
  }

  viewingCompany: string;
  // -------------------------------------------------------------------
  selectCompanyInfo(company) {
    this.viewingCompany = company.id;
    this.companySubjectId.next(company.id);
  }

  // -------------------------------------------------------------------
  closeCompanyInfo() {
    this.viewingCompany = null;
  }

  bsModalRef: BsModalRef;

  //-------------------------------------------------------------------
  deleteApplications(onFailure: onSmartFailure) {
    if (this.allPages) {
      this.accountService.bulkDeleteApplications(
        this.accountId,
        this.funnelId,
        this.searchFilter,
        async () => {
          await this.applicationPagination.refresh();
          this.clearSelection();
          this.bsModalRef.hide();
        },
        error => onFailure(error),
      );
      return;
    }

    this.candidateService.deleteApplications(
      this.subjectApplicationIds.getValue(),
      async () => {
        await this.applicationPagination.refresh();
        this.clearSelection();
        this.bsModalRef.hide();
      },
      error => {
        onFailure(error);
      },
    );
  }

  //-------------------------------------------------------------------
  cancelApplications(onFailure: onSmartFailure) {
    if (this.allPages) {
      this.accountService.bulkCancelApplications(
        this.accountId,
        this.funnelId,
        this.searchFilter,
        async () => {
          await this.applicationPagination.refresh();
          this.clearSelection();
          this.bsModalRef.hide();
        },
        error => onFailure(error),
      );
      return;
    }

    this.candidateService.cancelApplications(
      this.subjectApplicationIds.getValue(),
      async () => {
        await this.applicationPagination.refresh();
        this.clearSelection();
        this.bsModalRef.hide();
      },
      error => {
        onFailure(error);
      },
    );
  }

  //-------------------------------------------------------------------
  exportApplications(onFailure: onSmartFailure) {
    if (this.allPages) {
      this.funnelService.bulkExportApplications(
        this.accountId,
        this.funnelId,
        this.searchFilter,
        async () => {
          //await this.applicationPagination.refresh();
          this.clearSelection();
          this.bsModalRef.hide();
        },
        error => onFailure(error),
      );
      return;
    }

    this.funnelService.exportApplications(
      this.accountId,
      this.funnelId,
      this.subjectApplicationIds.getValue(),
      async () => {
        await this.applicationPagination.refresh();
        this.clearSelection();
        this.bsModalRef.hide();
      },
      error => {
        onFailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  resumeApplications(onFailure: onSmartFailure, resumeAt) {
    if (this.allPages) {
      this.accountService.bulkResumeApplications(
        this.accountId,
        this.funnelId,
        this.searchFilter,
        resumeAt,
        async () => {
          await this.applicationPagination.refresh();
          this.clearSelection();
          this.bsModalRef.hide();
        },
        error => onFailure(error),
      );
      return;
    }

    this.candidateService.resumeApplications(
      this.subjectApplicationIds.getValue(),
      resumeAt,
      async () => {
        await this.applicationPagination.refresh();
        this.clearSelection();
        this.bsModalRef.hide();
      },
      error => {
        onFailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  initDeleteApplicationsModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      onDelete: this.deleteApplications.bind(this),
    };

    this.bsModalRef = this.modalService.show(
      ModalConfirmDeleteApplicationsComponent,
      options,
    );
    // this.deleteApplications$ = this.bsModalRef.content.reason.subscribe(() => {
    //   this.deleteApplications();
    // });
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  // -------------------------------------------------------------------
  initResumeApplicationsModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      onResume: this.resumeApplications.bind(this),
    };

    this.bsModalRef = this.modalService.show(
      ModalConfirmResumeComponent,
      options,
    );

    this.bsModalRef.content.closeBtnName = 'Close';
  }

  // -------------------------------------------------------------------
  initCancelApplicationsModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      title: 'Confirm cancelling applications',
      onDelete: this.cancelApplications.bind(this),
      buttonTitle: 'Cancel',
    };

    this.bsModalRef = this.modalService.show(ModalConfirmComponent, options);

    this.bsModalRef.content.closeBtnName = 'Close';
  }

  // -------------------------------------------------------------------
  initExportApplicationsModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      title: 'Confirm exporting applications',
      onDelete: this.exportApplications.bind(this),
      buttonTitle: 'Export',
      confirmText: "You'll get an CSV with the data by email. Please confirm.",
    };

    this.bsModalRef = this.modalService.show(ModalConfirmComponent, options);

    this.bsModalRef.content.closeBtnName = 'Close';
  }

  // -------------------------------------------------------------------
  setPage(newPage: number) {
    this.currentPage = newPage;
    this.applicationPagination.setOffset((newPage - 1) * this.itemPerPage);
  }

  // -------------------------------------------------------------------
  setSubjectCandidateIds() {
    let selected: string[] = [];
    this.applicationPagination.items.forEach((candidate: any) => {
      if (candidate.selected) {
        selected.push(candidate.id);
      }
    });

    this.countSelected.next(selected.length);
    this.subjectApplicationIds.next(selected);
  }

  // -------------------------------------------------------------------
  toggleApplicationSelection(candidateId: string) {
    let all = this.subjectApplicationIds.getValue();

    if (!all) {
      all = [];
    }

    var index = all.indexOf(candidateId);
    if (index == -1) {
      // not found, we add it
      all.push(candidateId);
    } else {
      all.splice(index, 1);
    }
    this.subjectApplicationIds.next(all);
    this.allPages = false;
    this.countSelected.next(all.length); //this.candidatePagination.items.length);
  }

  // -------------------------------------------------------------------
  toggleGlobal() {
    if (this.countSelected.getValue() != this.applicationPagination.items.length) {
      this.selectOnePage();
    } else {
      this.clearSelection();
    }
  }

  // -------------------------------------------------------------------
  selectOnePage() {
    let selected = [];
    this.applicationPagination.items.forEach((application: any) => {
      selected.push(application.id);
    });
    this.countSelected.next(selected.length); //this.applicationPagination.items.length);
    this.subjectApplicationIds.next(selected);
    this.allPages = false;
  }

  // -------------------------------------------------------------------
  selectAllPages() {
    this.applicationPagination.items.forEach((application: any) => {
      application.selected = true;
    });
    this.countSelected.next(this.applicationPagination.totalCount);
    this.subjectApplicationIds.next(null);
    this.allPages = true;
  }

  // -------------------------------------------------------------------
  isApplicationSelected(applicationId) {
    if (this.allPages) {
      return true;
    }

    let all = this.subjectApplicationIds.getValue();
    if (!all) {
      return false;
    }

    return all.indexOf(applicationId) >= 0;
  }

  // -------------------------------------------------------------------
  clearSelection() {
    this.countSelected.next(null);
    this.subjectApplicationIds.next(null);
    this.allPages = false;
  }

  stages = [
    { id: 1, name: 'Ready To Start' },
    { id: 2, name: 'Progressing' },
    { id: 3, name: 'Rejected' },
    { id: 4, name: 'Expired' },
    { id: 5, name: 'Accepted' },
    { id: 6, name: 'Canceled' },
    { id: 7, name: 'Waiting' },
    { id: 8, name: 'Completed' },
  ];

  // -------------------------------------------------------------------
  changeStage(
    stage: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    if (!stage.value) {
      this.applicationPagination.searchFilter.include_stages.push(stage.id);
    } else {
      const index = this.applicationPagination.searchFilter.include_stages.indexOf(
        stage.id,
        0,
      );
      if (index > -1) {
        this.applicationPagination.searchFilter.include_stages.splice(index, 1);
      }
    }

    this.applicationPagination.setOffset(0, () => {
      stage.value = !stage.value;
      onsuccess();
      this.clearSelection();
    });
  }

  // -------------------------------------------------------------------
  closeApplicationInfo() {
  }

  // -------------------------------------------------------------------
  changeError(
    stage: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.applicationPagination.searchFilter.has_error = !this.hasError;

    this.applicationPagination.setOffset(0, () => {
      this.hasError = !this.hasError;
      onsuccess();
      this.clearSelection();
    });
  }
}
